import { render, staticRenderFns } from "./Filters.vue?vue&type=template&id=7170b489&"
import script from "./Filters.vue?vue&type=script&lang=js&"
export * from "./Filters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7170b489')) {
      api.createRecord('7170b489', component.options)
    } else {
      api.reload('7170b489', component.options)
    }
    module.hot.accept("./Filters.vue?vue&type=template&id=7170b489&", function () {
      api.rerender('7170b489', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/rentalBookings/widgets/Filters.vue"
export default component.exports